<template>
  <div
    ref="cardRef"
    :class="[$style.card_block, $style[type]]"
    @click.stop="itemClick"
  >
    <template v-if="type === 'portfolio'">
      <div :class="$style.portfolio_icon">
        <svg-sprite
          :type="'regular'"
          :name="'portfolio'"
          :size="72"
        />
      </div>
      <div :class="$style.card_details">
        <div :class="$style.name_wrapper">
          <div :class="[$style.star, favorite && $style.active]" @click.stop="favClick">
            <svg-sprite
              :type="favorite ? 'bold' : 'regular'"
              :name="'star'"
              :size="20"
            />
          </div>
          <div :class="$style.item_name" v-if="!isEditing">{{ item.name }}</div>
          <div :class="$style.item_input" v-else>
            <input
              ref="input"
              type="text"
              v-model="name"
              @click.stop
              @blur="updateName"
              @keyup.enter.stop="updateName"
            />
            <div :class="$style.input_actions">
              <div @click.stop>
                <icon-button
                  id="confirm_edit"
                  type="colored"
                  :icon="{ name: 'check' }"
                />
              </div>
              <div @click.stop>
                <icon-button
                  :icon="{ name: 'close-1' }"
                />
              </div>
            </div>
          </div>
          <icon-button
            v-if="!isEditing"
            :class="$style.edit"
            :icon="{ name:'more-2' }"
            size="small"
            @onClick="toggleContextMenu"
          />
        </div>
        <div :class="$style.metadata">
          <div v-for="data in metadata" :key="data">
            {{ data }}
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'button'">
      <svg-sprite
        :type="'regular'"
        :name="'plus-1'"
        :color="'#1565C0'"
        :size="20"
      />
      <div :class="$style.button_label">{{ item.name }}</div>
    </template>

    <context-menu 
      v-if="showContextMenu"
      :items="contextMenuItems"
      :position="contextMenuPosition"
      @selectItemMenu="onSelectContextItem($event)"
      @onClickOutside="onClickOutside"
      @closePopup="onClickOutside"
    />
  </div>
</template>

<script>
import iconButton from '../globalButton/withIcon/iconButton.vue';

export default {
  name: 'Card',
  components: { iconButton },
  props: {
    type: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    metadata: {
      type: Array,
      default: []
    }
  },
  emits: [
    'updateName',
    'startDelete',
    'itemClick',
    'favClick',
  ],
  beforeUnmount() {
    this.$refs.cardRef.closest('.gantt_scroll').removeEventListener('scroll', this.scrollableDivListener);
  },
  data() {
    return {
      isEditing: false,
      name: this.item.name,
      showContextMenu: false,
      contextMenuPosition: null
    };
  },
  methods: {
    updateName(event) {
      if (!this.isEditing) {
        return;
      }

      this.isEditing = false;

      if (event.type === 'blur') {
        if (!event.relatedTarget || event.relatedTarget.id !== 'confirm_edit') {
          this.name = this.item.name;
          return;
        }
      }

      this.$emit('updateName', { item: this.item, name: this.name.trim()});
    },
    toggleContextMenu(e) {
      e.stopPropagation();
      this.contextMenuPosition = e.target.getBoundingClientRect();
      this.showContextMenu = !this.showContextMenu;
    },
    onSelectContextItem(menuItem) {
      switch (menuItem) {
        case 'rename_portfolio':
          this.startEdit();
          break;
        case 'favorite_portfolio':
          this.favClick();
          break;
        case 'delete_portfolio':
          this.startDelete();
          break;
        default:
          break;
      }
    },
    onClickOutside() {
      this.showContextMenu = false;
    },
    startEdit() {
      this.isEditing = !this.isEditing;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    startDelete() {
      this.$emit('startDelete');
    },
    itemClick() {
      this.$emit('itemClick');
    },
    favClick() {
      this.$emit('favClick');
    },
    scrollableDivListener(e) {
      this.contextMenuPosition = null;
      this.showContextMenu = false;
    },
  },
  watch: {
    showContextMenu(newValue) {
      if (newValue) {
        this.$refs.cardRef.closest('.gantt_scroll').addEventListener('scroll', this.scrollableDivListener);
      } else {
        this.$refs.cardRef.closest('.gantt_scroll').removeEventListener('scroll', this.scrollableDivListener);
      }
    }
  },
  computed: {
    favorite() {
      return this.item.is_favorite;
    },
    contextMenuItems() {
      return [
        {
          name: __('common_rename'),
          id: 'rename_portfolio',
          icon: 'pensil',
          gpTestId: 'gp_autotest_rename_portfolio',
          iconType: 'regular',
          iconSize: 24,
          iconColor: '#191919',
        },
        {
          name: this.favorite ? __('settings_multiview_unfavorite') : __('settings_multiview_favorite'),
          id: 'favorite_portfolio',
          icon: this.favorite ? 'unfavorite' : 'star',
          gpTestId: 'gp_autotest_favorite_portfolio',
          iconType: 'regular',
          iconSize: 24,
          iconColor: '#191919',
        },
        {
          name: __('settings_multiview_delete'),
          id: 'delete_portfolio',
          icon: 'delete',
          gpTestId: 'gp_autotest_delete_portfolio',
          iconType: 'regular',
          iconSize: 24,
          iconColor: '#DD3636',
          labelColor: '#DD3636'
        }
      ];
    }
  }
}
</script>

<style module src="./less/card.less"></style>